import { render, staticRenderFns } from "./SalesGridCustomerBox.vue?vue&type=template&id=9f55ac84&scoped=true&"
import script from "./SalesGridCustomerBox.vue?vue&type=script&lang=js&"
export * from "./SalesGridCustomerBox.vue?vue&type=script&lang=js&"
import style0 from "./SalesGridCustomerBox.vue?vue&type=style&index=0&id=9f55ac84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f55ac84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\kaffa_machine\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f55ac84')) {
      api.createRecord('9f55ac84', component.options)
    } else {
      api.reload('9f55ac84', component.options)
    }
    module.hot.accept("./SalesGridCustomerBox.vue?vue&type=template&id=9f55ac84&scoped=true&", function () {
      api.rerender('9f55ac84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/components/SalesGridCustomerBox.vue"
export default component.exports